/**
 * Constantes do site e contactos.
 */

export const SITE_URL = "https://oficinadamente.top";
export const SITE_NAME = "Oficina da Mente";

export const CONTACT = {
  phone: "+351962689201",
  phoneDisplay: "96 26 89 201",
  email: "oficinadamente2016@gmail.com",
  address: {
    street: "Travessa do Ferro nº 7",
    locality: "Moure de Madalena",
    postalCode: "3515-336",
    region: "Viseu",
    country: "PT",
    display: "Travessa do Ferro nº7, Moure de Madalena, 3515-336 Viseu",
  },
} as const;

export const SOCIAL = {
  // Adicionar redes sociais quando existirem
} as const;

export const OWNER = {
  name: "Pedro de Freitas",
  title: "Hipnoterapeuta & Formador",
  experienceStartYear: 1997,
} as const;
